import { IUserBookingsListData } from "@/api_framework/api_modals/Bookings";
import ModalDoubleAction from "@/app/components/ui/Modals/DoubleAction";
import { useUserBookingsPaymentHistoryAPI } from "@/app/hooks/api_hooks/bookings/useUserBookingsPaymentHistoryAPI";
import { useModalActions } from "@/app/hooks/ui_hooks/useModalActions";
import { useModalState } from "@/app/hooks/ui_hooks/useModalState";
import { BsCheck2Circle } from "react-icons/bs";
import { MdCurrencyRupee } from "react-icons/md";

export interface IEditBookingCommentModalState {
  bookingDetails: IUserBookingsListData;
}

export interface IBookingCommentsFormFields {
  coupon: string;
  alternativeCoupon: string;
  membershipName: string;
  otherComment: string;
  lateBooking: boolean;
  lateBookingStartTime: string;
  vaccination: boolean;
  hygienePackage: boolean;
}

const BookingsPaymentStatus = () => {
  const { bookingDetails } = useModalState("BOOKINGS_PAYMENT_STATUS") as IEditBookingCommentModalState;

  const { setInvisible } = useModalActions("BOOKINGS_PAYMENT_STATUS");
  const { execute: fetchPaymentHistory, paymentDetails } = useUserBookingsPaymentHistoryAPI();

  const handleFetchBookingStatus = () => {
    fetchPaymentHistory(bookingDetails?.booking_id);
  };
  const paymentStatus = (status: string) => {
    let text_color = null;
    if (status === "pending") {
      text_color = "text-yellow-400";
    } else if (status === "paid") {
      text_color = "text-green-400";
    } else if (status === "refunded") {
      text_color = "text-orange-400";
    } else if (status === "refund initiated") {
      text_color = "text-yellow-400";
    } else if (status === "charged") {
      text_color = "text-red-400";
    } else if (status === "refund failed") {
      text_color = "text-red-400";
    }
    return text_color;
  };

  return (
    <ModalDoubleAction
      showIcon={false}
      contentOverflow={true}
      onVisibleCallback={handleFetchBookingStatus}
      modalId="BOOKINGS_PAYMENT_STATUS"
      button={{
        primaryButtonText: "Okay",

        primaryButtonClassname: `bg-[#193A6A] text-white text-left`,
        secondaryButtonText: "Close",
        primaryCallback: () => {
          setInvisible();
        },
        shouldHideOnClick: false,
      }}
      content={
        <div className="w-full p-2">
          <div className="w-full">
            {paymentDetails?.map((item, id) => {
              return (
                <div className="" key={id}>
                  <h2 className="text-[#737373] font-semibold text-[11px]  ">{item?.payment_date}</h2>
                  {item?.payment_details?.map((pay, idX) => {
                    return (
                      <div className="flex gap-3 w-full my-4" key={idX}>
                        <div className="w-auto">
                          <BsCheck2Circle className="w-5 h-5" />
                        </div>
                        <div className="flex flex-col w-72">
                          <p className="text-[#141414] text-sm font-normal">{pay?.payment_status}</p>
                          <p
                            className={`flex items-center ${paymentStatus(pay?.payment_status?.toLowerCase())} text-sm`}
                          >
                            {pay?.script}
                          </p>
                        </div>
                        <div className="w-auto">
                          <p className="text-[#737373] text-sm">{pay?.payment_time}</p>
                        </div>
                      </div>
                    );
                  })}
                </div>
              );
            })}
          </div>
        </div>
      }
      title="Payment Status"
      titleIcon="GrAndroid"
      titleIconClassName="text-green-500"
    />
  );
};
export default BookingsPaymentStatus;
